import { useServiceReport } from './hooks';
import { ServiceReportPresentation } from './presentations';

export const ServiceReport = () => {
  const {
    state: { filteredServiceApplications, loading, currentPage, totalPage, totalCount },
    actions: { handleOutputCsv, handlePageChange, handleHeaderSort },
  } = useServiceReport();

  return (
    <ServiceReportPresentation
      filteredServiceApplications={filteredServiceApplications}
      loading={loading}
      currentPage={currentPage}
      totalPage={totalPage}
      totalCount={totalCount}
      handleOutputCsv={handleOutputCsv}
      handlePageChange={handlePageChange}
      handleHeaderSort={handleHeaderSort}
    />
  );
};
